import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Navbar.css';
import logo from '../assets/logo.png';

function Navbar() {
  const { user, signInWithGitHub, signOut } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleSignIn = async () => {
    await signInWithGitHub();
  };

  const handleSignOut = async () => {
    await signOut();
  };

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/" onClick={closeMobileMenu}>
          <img src={logo} alt="CodeBounty logo" className="navbar-logo" />
          CodeBounty
        </Link>
      </div>

      <button
        className={`hamburger-button ${mobileMenuOpen ? 'open' : ''}`}
        onClick={toggleMobileMenu}
        aria-label="Toggle navigation menu"
        aria-expanded={mobileMenuOpen}
      >
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
        <span className="hamburger-line"></span>
      </button>

      <div className={`navbar-links ${mobileMenuOpen ? 'open' : ''}`}>
        <Link to="/tasks" className={location.pathname === '/tasks' ? 'active' : ''} onClick={closeMobileMenu}>Browse Tasks</Link>
        <Link to="/my-tasks" className={location.pathname === '/my-tasks' ? 'active' : ''} onClick={closeMobileMenu}>My Tasks</Link>
        <Link to="/leaderboard" className={location.pathname === '/leaderboard' ? 'active' : ''} onClick={closeMobileMenu}>Leaderboard</Link>
        <Link to="/projects" className={location.pathname === '/projects' ? 'active' : ''} onClick={closeMobileMenu}>My Projects</Link>
        <Link to="/agent-dashboard" className={location.pathname === '/agent-dashboard' ? 'active' : ''} onClick={closeMobileMenu}>Create Project</Link>
        <Link to="/wallet" className={location.pathname === '/wallet' ? 'active' : ''} onClick={closeMobileMenu}>Wallet</Link>
        <Link to="/settings" className={location.pathname === '/settings' ? 'active' : ''} onClick={closeMobileMenu}>Settings</Link>
      </div>

      <div className="navbar-auth">
        {user ? (
          <div className="user-info">
            <div className="user-avatar">
              {user.user_metadata?.avatar_url ? (
                <img
                  src={user.user_metadata.avatar_url}
                  alt={user.user_metadata?.name || 'User'}
                  className="avatar-image"
                />
              ) : (
                <div className="avatar-placeholder">
                  {user.user_metadata?.name?.charAt(0) || user.email?.charAt(0) || 'U'}
                </div>
              )}
            </div>
            <span className="user-name">
              {user.user_metadata?.name || user.email}
            </span>
            <button onClick={handleSignOut} className="auth-button signout-button">
              Sign Out
            </button>
          </div>
        ) : (
          <button onClick={handleSignIn} className="auth-button signin-button">
            <svg className="github-icon" viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
              <path d="M12 0C5.37 0 0 5.37 0 12c0 5.31 3.435 9.795 8.205 11.385.6.105.825-.255.825-.57 0-.285-.015-1.23-.015-2.235-3.015.555-3.795-.735-4.035-1.41-.135-.345-.72-1.41-1.23-1.695-.42-.225-1.02-.78-.015-.795.945-.015 1.62.87 1.845 1.23 1.08 1.815 2.805 1.305 3.495.99.105-.78.42-1.305.765-1.605-2.67-.3-5.46-1.335-5.46-5.925 0-1.305.465-2.385 1.23-3.225-.12-.3-.54-1.53.12-3.18 0 0 1.005-.315 3.3 1.23.96-.27 1.98-.405 3-.405s2.04.135 3 .405c2.295-1.56 3.3-1.23 3.3-1.23.66 1.65.24 2.88.12 3.18.765.84 1.23 1.905 1.23 3.225 0 4.605-2.805 5.625-5.475 5.925.435.375.81 1.095.81 2.22 0 1.605-.015 2.895-.015 3.3 0 .315.225.69.825.57A12.02 12.02 0 0024 12c0-6.63-5.37-12-12-12z"/>
            </svg>
            Sign in with GitHub
          </button>
        )}
      </div>
    </nav>
  );
}

export default Navbar; 